export default __webpack_public_path__ + "static/media/contemplative-reptile.7ab41865.jpg";